import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { UpdateCustomersRequest } from '@cash-web/shared-util-protos/squareup/cash/supportal/service.pb'
import { UpdateCustomersResponse } from '@cash-web/shared-util-protos/squareup/cash/supportal/service.pb'

export const updateCustomers = (request: UpdateCustomersRequest, options?: CashRequestOptions) =>
  post<UpdateCustomersRequest, UpdateCustomersResponse>('/2.0/cash/update-customers', request, {
    ...options,
    rejectOnError: true,
  })
